import { BookOutlined, FormOutlined, HighlightOutlined, InfoCircleOutlined, PhoneOutlined, ShopOutlined, ShoppingCartOutlined } from "@ant-design/icons"

export const SCHEDULE_STATUS: any = {

  SCHEDULED: {color: "dodgerblue"},
  ERROR: {color: "MediumVioletRed"},		
  LAUNCHED: {color: "green"},		
}

export const CTA_TYPE: any = {

  BOOK: {name: "Reservar", icon: BookOutlined},  
  ORDER: {name: "green", icon: HighlightOutlined},	
  SHOP: {name: "Comprar", icon: ShoppingCartOutlined},  
  LEARN_MORE: {name: "Más Información", icon: InfoCircleOutlined},	
  SIGN_UP: {name: "green", icon: FormOutlined},	
  CALL: {name: "Llamar", icon: PhoneOutlined}
}